import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LangTranslate } from "../types/translate.types";

interface IAdminState {
  langTranslate: LangTranslate[];
}

const initialState: IAdminState = {
  langTranslate: [],
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setListTranslate(state, action: PayloadAction<LangTranslate[]>) {
      state.langTranslate = action.payload;
    },
 updateListTranslate(state, action: PayloadAction<{ index: number; newTranslate: string }>) {
    console.log(action.payload.index); 
    console.log(JSON.stringify(state.langTranslate)); 

  const item=state.langTranslate[action.payload.index];
      if (item) {
        
    item.translate = action.payload.newTranslate;
        console.log(JSON.stringify(state.langTranslate)); 

  } else {
    console.warn("Invalid index in updateListTranslate:", action.payload.index);
  }
 }
},
});

export const { setListTranslate,updateListTranslate} = adminSlice.actions;
export default adminSlice.reducer;
